import React, { useEffect, useState } from 'react';
import './style.css';

export default ({ cmsData }) => {
    let { bgImage = {}, sections = [], descBgImage } = cmsData;
    var bgImageStyle;
    if (bgImage) {
        bgImageStyle = {
            backgroundImage: `url(${process.env.REACT_APP_API_DOMAIN}${bgImage.url})`,
        }
    }
    var descbgImageStyle;
    if (descBgImage) {
        descbgImageStyle = {
            backgroundImage: `url(${process.env.REACT_APP_API_DOMAIN}${descBgImage.url})`,
        }
    }
     
    
    const [animate, doAnimate] = useState(true);
    const [data, setData] = useState([0, 1]);
    const [showDesc,setShowDesc] = useState(true);
    useEffect(() => {
        let timeout;
        if (animate == true) {
            timeout = setTimeout(() => {
                if (data[0] >= sections.length - 1) {
                    setData([0, 1])
                } else {
                    if ((data[0] + 2) == sections.length) {
                        let newIdx = data[0] + 1;
                        setData([newIdx, 0])
                    } else {
                        let newIdx = data[0] + 1;
                        let newIdxNext = newIdx + 1;
                        setData([newIdx, newIdxNext]);
                    }
                }
            }, 10000);
        }
        return () => {
            clearTimeout(timeout);
            // Cleanup
        };

    }, [data, animate]);

    const stopAnimation = ()=>{
    
        doAnimate(!animate)
        setShowDesc(!showDesc);
    }


    return <div className="image-container">
    <div className='fullscreen-wrapper' style={bgImageStyle}>       
        <div className="banner-container">
            {sections.map((section, i) => {
                return <div className={"banner " + ((data[0] == i) ? "show" : "") + ((data[1] == i) ? "show top" : "")} key={i} >
                    <img src={`${process.env.REACT_APP_API_DOMAIN}${section.image.url}`} className={"object-contain banner-image " + ((data[1] == i) ? "swipe" : "")} />
                </div>
            })}
        </div>
    </div>
    <div className='text-container'>
        <div className='text-section opacity-90'>
            <div className='text-head' >
            {sections.map((section, i) => {                
                return <>
                    <span className={i == data[1]?'show':''}>{section.heading}</span>
                    {showDesc == true && <div className={'text-desc ' + (i == data[1]?'show':'hide')} style={descbgImageStyle} ><div>{(i==data[1] && showDesc == true)? section.description:''}</div></div>}
                </>
            })}
            </div>
            </div>
            <div className='text-desc-section'>
            </div>
        </div>

    </div>
};
